module.exports = __webpack_public_path__ + "static/media/logo.c38b45c2.svg";